import {createContext, ReactNode,} from "react";
import {RouteMeta} from "../../SecureRoutes";

export const RouteMetaContext = createContext<RouteMeta | null>(null);

export interface RouteMetaContextProviderProps {
  children: JSX.Element;
  meta?: RouteMeta;
}

export const RouteMetaContextProvider = ({children, meta}: RouteMetaContextProviderProps) => {
  if (!meta) {
    return children;
  }

  return (
    <RouteMetaContext.Provider value={meta}>
      {children}
    </RouteMetaContext.Provider>
  );
};